/**
 * Clases Tailwind compartidas — superficie oscura “learn” (Escalas y módulos hermanos).
 * Colores de acento vienen de CSS: --bordona-accent, --bordona-accent-hover, etc.
 */
export const learnSurface = {
  label: "text-[10px] font-semibold uppercase tracking-wider text-slate-400 font-sans mb-1.5 block",
  labelMb2: "text-[10px] font-semibold uppercase tracking-wider text-slate-400 font-sans mb-2 block",
  btnPrimary: "bg-[var(--bordona-accent)] text-white shadow-sm",
  btnInverse: "bg-slate-900/80 text-white border border-white/12",
  btnGhost: "bg-white/[0.07] text-slate-200 hover:bg-white/10 border border-white/10",
  btnGhostPlain: "bg-white/[0.07] text-slate-200 hover:bg-white/10",
  panel: "p-3 rounded-xl bg-white/[0.08] border border-white/10",
  panelLoose: "p-4 rounded-2xl bg-white/[0.08] border border-white/10",
  divider: "border-white/10",
  textMuted: "text-slate-400",
  textBody: "text-slate-200",
  textStrong: "text-slate-100",
  subtleBadge: "rounded-md text-xs font-sans font-bold bg-white/[0.07] text-slate-200 border border-white/10",
} as const;
